import React from 'react';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import Row from '../../../core/layout/Row';
import PropTypes from 'prop-types';
import { realCurrencyFormatter, dollarCurrencyFormatter, CONTRACT_PRODUCTS } from '../../../core/consts';

const BillProductsList = (props) => (
  <Row>
    <Table
      columns={[
        {
          label: 'Product',
          path: 'name',
        },
        {
          label: 'Description',
          path: 'description',
        },
        {
          label: 'Amount',
          path: 'amount',
          width: '150px',
        },
        {
          label: 'Unit Price',
          path: 'unitPrice',
          width: '150px',
          render: (cell) => {
            return props.currencyType === 'real'
              ? realCurrencyFormatter.format(cell)
              : dollarCurrencyFormatter.format(cell);
          },
        },
        {
          label: 'Net Unit Price',
          path: 'unitPrice',
          width: '150px',
          render: (cell, row) => {
            let value = cell;
            if (row.discount) {
              value = cell - (cell * row.discount) / 100;
            }

            return props.currencyType === 'real'
              ? realCurrencyFormatter.format(value)
              : dollarCurrencyFormatter.format(value);
          },
        },
        {
          label: 'Discount',
          path: 'discount',
          width: '100px',
          render: (cell) => (!!cell ? `${cell}%` : '-'),
        },
        {
          label: 'Installment Number',
          path: 'installmentNumber',
          width: '150px',
          render: (value, row) => (value ? `${value}${row.installments ? `/${row.installments}` : ''}` : null),
        },
        ...(!props.readOnly
          ? [
              {
                label: 'Actions',
                width: '100px',
                render: (cell, row) => (
                  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                    {row?.hs_sku !== CONTRACT_PRODUCTS.EXTRA_LICENSE_SEAT_PROPORTIONAL && (
                      <Button icon="edit" disabled={props.submitting} onClick={() => props.onEdit(row)} />
                    )}
                    <Button icon="delete" disabled={props.submitting} onClick={() => props.onDelete(row)} />
                  </div>
                ),
              },
            ]
          : []),
      ]}
      rows={props.data}
    />
  </Row>
);

BillProductsList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      amount: PropTypes.number,
      installments: PropTypes.string,
      installmentNumber: PropTypes.string,
      unitPrice: PropTypes.number.isRequired,
    })
  ),
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  submitting: PropTypes.bool,
  currencyType: PropTypes.oneOf(['real', 'dollar']),
};

BillProductsList.defaultProps = {
  data: [],
  submitting: false,
  currencyType: 'real',
  readOnly: false,
};

export default BillProductsList;
